/**
 * Accordion Module - Enhanced with details/summary support
 */

export default function initAccordion() {
  const accordions = document.querySelectorAll('.accordion');
  if (!accordions.length) return;

  accordions.forEach(accordion => {
    const items = accordion.querySelectorAll('.accordion-item');
    
    items.forEach(item => {
      const summary = item.querySelector('.accordion-header');
      
      summary.addEventListener('click', (e) => {
        // Optional: Close other items (remove for multi-open behavior)
        const shouldCloseOthers = !accordion.classList.contains('multi-open');
        
        if (shouldCloseOthers) {
          items.forEach(otherItem => {
            if (otherItem !== item && otherItem.hasAttribute('open')) {
              otherItem.removeAttribute('open');
            }
          });
        }
        
        // The native details/summary will handle the open/close automatically
        // We just need to handle the optional close-others behavior
      });
    });
  });
}

// Auto-initialize
document.addEventListener('DOMContentLoaded', initAccordion);
